var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"display":"block","width":"100vw","height":"100vh"},attrs:{"id":"test","src":((_vm.$store.state.env.defaultV2Api.host) + "/test"),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }